module.exports = new __parcel__URL__("quake-ii.c9fb184a.jpg").toString();